import Header from '../Header/Header'
import industrystar from '../../../assets/images/icons/industrystar.svg'
import CommonHeroSection from '../commonherosection/CommonHeroSection'

const IndustryHero = () => {
  return (
    <CommonHeroSection wrapperClassName="relative max-h-[85vh] overflow-hidden" contentClassName="relative z-20 w-full">
      <div className="relative">
        <Header />
      </div>

      <div className="relative flex min-h-[60vh] md:min-h-[75vh] lg:min-h-[85vh] items-center justify-center px-4 text-center">
        <div className="relative mb-[10%] w-full">
          <div className="relative mx-auto w-fit max-w-6xl">
            <h1
              className="font-rajdhani text-4xl font-bold text-white
              md:text-5xl lg:text-6xl xl:text-7xl 2xl:text-8xl"
            >
              Solutions Built for Your Industry
            </h1>

            <img
              src={industrystar}
              alt="heading icon"
              className="pointer-events-none absolute
              right-5 -top-12 md:-right-1 md:-top-15 lg:-right-20 lg:-top-8 xl:-right-20 xl:-top-10 2xl:right-10 2xl:-top-10
              h-10 w-10 md:h-15 md:w-15 lg:h-15 lg:w-15 xl:h-18 xl:w-18 2xl:h-20 2xl:w-20
              animate-star"
            />
          </div>

          <p
            className="mx-auto mt-10 font-gilroy-medium text-lg leading-tight text-gray-400
            md:max-w-[100%] md:text-3xl lg:max-w-[90%] lg:text-3xl xl:max-w-[80%] xl:text-4xl 2xl:text-5xl"
          >
            Deep domain expertise means we speak your language, understand your constraints, & anticipate your needs. We don't just build software—we solve industry-specific problems.
          </p>

          <img
            src={industrystar}
            alt="decorative star"
            className="pointer-events-none absolute
            left-2 top-[98%] md:left-8 md:top-[90%] lg:left-14 lg:top-[82%] xl:left-18 xl:top-[84%] 2xl:left-24 2xl:top-[86%]
            h-8 w-8 md:h-12 md:w-12 lg:h-14 lg:w-14 xl:h-16 xl:w-16 2xl:h-18 2xl:w-18
            animate-star"
          />
        </div>
      </div>
      <style>
        {`
    @keyframes starBlink {
      0%, 100% {
        transform: scale(1);
        filter: brightness(1);
        opacity: 0.9;
      }
      50% {
        transform: scale(1.35);
        filter: brightness(2) drop-shadow(0 0 10px rgba(255,255,255,0.9));
        opacity: 1;
      }
    }

    .animate-star {
      animation: starBlink 1.6s ease-in-out infinite;
    }
  `}
      </style>
    </CommonHeroSection>
  )
}

export default IndustryHero
